import ImageIcon from "@mui/icons-material/Image";
import TextFieldsIcon from "@mui/icons-material/TextFields";
import {
  Box,
  TextField,
  Typography,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import { motion } from "framer-motion";
import React, { useState, useRef } from "react";

interface PostEditorProps {
  content: string;
  onChange: (value: string) => void;
  onGenerate: (prompt: string, genImage: boolean) => void;
}

export const PostEditor: React.FC<PostEditorProps> = ({ content, onChange, onGenerate }) => {
  const [openPrompt, setOpenPrompt] = useState(false);
  const [prompt, setPrompt] = useState("");
  const [isImageGeneration, setIsImageGeneration] = useState(false);
  const wordCount = content.split(/\s+/).filter(Boolean).length;

  const handleTogglePrompt = (forImage: boolean) => {
    setIsImageGeneration(forImage);
    setOpenPrompt(true);
  };

  const handleClosePrompt = () => {
    setOpenPrompt(false);
    setPrompt("");
  };

  const handleGenerate = () => {
    if (prompt.trim()) {
      onGenerate(prompt.trim(), isImageGeneration);
      setPrompt("");
      setOpenPrompt(false);
    }
  };

  return (
    <Box sx={{ position: "relative", p: 2, borderRadius: 2, bgcolor: "background.paper" }}>
      <TextField
        fullWidth
        multiline
        minRows={6}
        variant="outlined"
        placeholder="Cosa vuoi condividere sui tuoi social?"
        value={content}
        onChange={(e) => onChange(e.target.value)}
        sx={{
          "& .MuiOutlinedInput-root": {
            "& fieldset": { border: "none" },
          },
        }}
      />

      {/* Stats and buttons bar */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mt: 1,
          p: 1,
          borderRadius: 2,
          bgcolor: "grey.100",
          flexWrap: "wrap",
          gap: 1,
        }}
      >
        <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
          <Typography variant="caption" color="textSecondary">
            {content.length} / 280 caratteri
          </Typography>
          <Typography variant="caption" color="textSecondary">
            ({wordCount} parole)
          </Typography>
        </Box>
        <Box sx={{ display: "flex", gap: 1 }}>
          <Button
            variant="contained"
            color="primary"
            className="sfumatebtn"
            onClick={() => handleTogglePrompt(false)}
            startIcon={<TextFieldsIcon />}
          >
            Genera Testo
          </Button>
          <Button
            variant="contained"
            color="secondary"
            className="sfumatebtn"
            onClick={() => handleTogglePrompt(true)}
            startIcon={<ImageIcon />}
          >
            Genera Immagine
          </Button>
        </Box>
      </Box>

      {/* Prompt Dialog */}
      <Dialog open={openPrompt} onClose={handleClosePrompt} fullWidth maxWidth="sm">
        <DialogTitle>
          {isImageGeneration ? "Genera un'immagine con AI" : "Genera un testo con AI"}
        </DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Prompt"
            type="text"
            fullWidth
            variant="outlined"
            value={prompt}
            onChange={(e) => setPrompt(e.target.value)}
            placeholder={
              isImageGeneration
                ? "Descrivi l'immagine che vorresti generare..."
                : "Descrivi il contenuto che vorresti generare..."
            }
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClosePrompt}>Annulla</Button>
          <Button
            variant="contained"
            onClick={handleGenerate}
            disabled={!prompt.trim()}
            color={isImageGeneration ? "secondary" : "primary"}
          >
            Genera
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};
